exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#corporate-government .mdl-tabs__tab-bar{margin-bottom:0;overflow:visible;display:block}#corporate-government .container h1,#corporate-government .container h2,#corporate-government .container h3{margin-bottom:30px;font-weight:700;font-size:18px;letter-spacing:1px}#corporate-government .container ul{color:#404047}@media (max-width:767px){#tab-selector-cg{left:50%;right:0;width:50%}#tab-selector-cg .tab-select-icon{right:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/about/corporate-governance.vue
// module id = 272
// module chunks = 0